import { client } from '@/common-utils/libraries/axios/axios';
import { SIM_ORDER_MAIL } from '../apiUrls';

const mutationOrderSimCard = (onSuccess, onError) => {
    return {
        mutationFn: (dataToSend) => {
            return client.post(SIM_ORDER_MAIL.DETAILS.url, dataToSend);
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationOrderSimCard;